export default {
	about_the: 'Sobre las',
	document: 'Documento',
	company_agency: 'Tienda registrada en tu perfil:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explora todo nuestro universo de cursos, vídeos, artículos y archivos.',
	project_name: 'Educa Tigre',
	welcome_to: 'Bienvenido(a) la',
	challenge_of_the_day: "Desafío de las Bestias \\ Desafío Extra",
	profession: '¿Cuál es tu área de actividad hoy?',
}
